(() => {
  'use strict';

  const all = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));
  const one = (selector, scope = document) => scope.querySelector(selector);

  function setVideoState(card, state, message) {
    card.classList.toggle('is-playing', state === 'playing');
    card.classList.toggle('is-paused', state === 'paused');
    card.setAttribute('aria-pressed', state === 'playing' ? 'true' : 'false');
    const status = one('[data-ps-video-status-v2]', card);
    if (status) status.textContent = message || '';
  }

  function installVideoCards() {
    all('[data-ps-video-card-v2]').forEach((card) => {
      const video = one('[data-ps-video-v2]', card);
      if (!video) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');

      const play = () => {
        setVideoState(card, 'paused', 'Loading…');
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(() => {
            setVideoState(card, 'paused', 'Tap to play');
          });
        }
      };

      const toggle = () => {
        if (video.paused || video.ended) play();
        else video.pause();
      };

      card.addEventListener('click', toggle);
      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          toggle();
        }
      });

      video.addEventListener('play', () => setVideoState(card, 'playing', ''));
      video.addEventListener('pause', () => {
        if (!video.ended) setVideoState(card, 'paused', 'Tap to resume');
      });
      video.addEventListener('waiting', () => {
        if (!video.paused) setVideoState(card, 'playing', 'Buffering…');
      });
      video.addEventListener('canplay', () => {
        if (!video.paused) setVideoState(card, 'playing', '');
      });
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        setVideoState(card, 'paused', 'Replay');
      });
      video.addEventListener('error', () => setVideoState(card, 'paused', 'Video unavailable'));
      setVideoState(card, 'paused', 'Tap to play');
    });
  }

  function installReviewDrawer() {
    const drawer = one('[data-review-drawer]');
    if (!drawer) return;

    const trigger = one('[data-review-drawer-open]', drawer);
    const panel = one('[data-review-drawer-panel]', drawer);
    const closer = one('[data-review-drawer-close]', drawer);
    const reviewLink = one('.ps-review-drawer-link', drawer);
    if (!trigger || !panel) return;

    const open = () => {
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => {
        if (closer) closer.focus();
      }, 0);
    };
    const close = () => {
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', () => (panel.hidden ? open() : close()));
    if (closer) closer.addEventListener('click', close);
    if (reviewLink) {
      reviewLink.addEventListener('click', (event) => {
        event.preventDefault();
        close();
        const reviews = one('.ps-home-reviews') || one('#reviews');
        if (reviews) reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) {
        close();
        trigger.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!panel.hidden && !drawer.contains(event.target)) close();
    });
  }

  function fixProductTextWrap() {
    all('.ps-product-info h1, .ps-card-title, .ps-product-short').forEach((element) => {
      element.style.overflowWrap = 'anywhere';
    });
  }

  function start() {
    installVideoCards();
    installReviewDrawer();
    fixProductTextWrap();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
